import appDispatcher from "../../views/appSettings/dispatcher.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("dispatcher", {
    url: "dispatcher/:id",
    parent: "app",
    views: {
      view: {
        template: appDispatcher,
      },
    },
    reloadOnSearch: false,
    data: { title: "Dispatcher" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/dispatcher/dispatcher.urls.js